import React, { useState, useCallback } from 'react';
import { Auth } from 'aws-amplify';
import Loader from '@ts/ui/Loader';
import { userResetPassword } from '@ts/utils/iterableUtils';
import { forms } from '../data';
import * as S from '../styles';

/* eslint-disable security/detect-possible-timing-attacks */
function NewPasswordForm({ userEmail, setActiveForm }) {
    const [formData, updateFormData] = useState({
        resetcode: '',
        password: '',
        confpassword: '',
    });
    const [error, updateError] = useState('');
    const [isLoading, updateIsLoading] = useState(false);
    const [isSuccess, updateIsSuccess] = useState(false);

    const validateForm = useCallback(() => {
        if (!formData.resetcode) {
            updateError('Type your reset code from email');
            return false;
        }
        if (!formData.password) {
            updateError('Type your new password');
            return false;
        }
        if (!formData.confpassword) {
            updateError('Confirm your new password');
            return false;
        }
        if (formData.password !== formData.confpassword) {
            updateError('Passwords did not match');
            return false;
        }
        updateError('');
        return true;
    }, [formData, updateError]);

    const onChange = useCallback(
        ({ target }) =>
            updateFormData({
                ...formData,
                [target.name]: target.value,
            }),
        [formData, updateFormData]
    );

    const onSubmit = useCallback(
        (event) => {
            event.preventDefault();
            if (validateForm() && !isLoading) {
                updateIsLoading(true);
                const { resetcode, password } = formData;
                Auth.forgotPasswordSubmit(userEmail, resetcode, password)
                    .then(() => {
                        userResetPassword(userEmail);
                        updateIsLoading(false);
                        updateIsSuccess(true);
                    })
                    .catch((err) => {
                        updateIsLoading(false);
                        updateError(err.message);
                    });
            }
        },
        [
            validateForm,
            updateIsLoading,
            updateError,
            formData,
            isLoading,
            userEmail,
            updateIsSuccess,
        ]
    );

    return isSuccess ? (
        <S.Form>
            <S.Subtitle>Your password has been successfully changed!</S.Subtitle>
            <S.TextWrapper>
                <S.Text>Now, you can</S.Text>
                <S.BlueButton onClick={() => setActiveForm(forms.signin)}>
                    sign in
                </S.BlueButton>{' '}
                with new password
            </S.TextWrapper>
        </S.Form>
    ) : (
        <S.Form>
            <S.Subtitle>Check your email for a password reset verification code.</S.Subtitle>
            <S.InnerTitle>
                We’re sending you an email. Sometimes it can take a few minutes. If you are having
                trouble finding it, it is sent from:
            </S.InnerTitle>
            <S.InnerTitle>no-reply@verificationemail.com</S.InnerTitle>
            {error && <S.Error>{error}</S.Error>}
            <S.Label isRequired>Your reset code</S.Label>
            <S.Input type="tel" value={formData.resetcode} name="resetcode" onChange={onChange} />
            <S.Label isRequired>New Password</S.Label>
            <S.Input
                type="password"
                value={formData.password}
                name="password"
                onChange={onChange}
            />
            <S.Label isRequired>New Password (Confirm)</S.Label>
            <S.Input
                type="password"
                value={formData.confpassword}
                name="confpassword"
                onChange={onChange}
            />
            <S.SubmitButton onClick={onSubmit} disabled={isLoading}>
                {isLoading ? (
                    <S.LoaderWrap>
                        <Loader size="massive" />
                    </S.LoaderWrap>
                ) : (
                    'Change password'
                )}
            </S.SubmitButton>
        </S.Form>
    );
}

export default NewPasswordForm;
export { NewPasswordForm };
